
export function isMobileDevice(): boolean {
    if (window.innerWidth < 500) {
        return true;
    }
    return false;
}